<template>
  <section class="download-app py-15">
    <div class="pill pill--sm" style="left: 1rem; top: 1rem; animation-delay: .1s;"></div>
    <div class="pill pill--sm" style="left: 45rem; top: 33rem; animation-delay: .1s;"></div>
    <div class="pill pill--sm" style="left: 40rem; top: 15rem; animation-delay: .2s;"></div>
    <div class="pill pill--sm" style="left: 25rem; top: 38rem; animation-delay: .5s;"></div>
    <div class="pill pill--md" style="left: -5rem; top: 13rem"></div>
    <div class="pill pill--md" style="left: 23rem; top: -5rem; animation-delay: .3s;"></div>
    <div class="pill pill--lg" style="left: 8rem; top: 18rem; animation-delay: .2s;"></div>

    <v-img class="download-app__img" src="@/assets/e-imza-bilgilendirme.jpg" contain aspect-ratio="1.7"> </v-img>

    <div class="d-flex justify-center flex-wrap mt-5">

      <v-btn
        class="white--text ma-1"
        :href="isVatan ? 'https://play.google.com/store/apps/details?id=com.vatansmscom.plus' : ''"
        target="blank"
        large
        color="black"
      >
        <v-icon class="mr-4" left large>mdi-google-play</v-icon>
        <div class="text-left">
          <div class="text-capitalize">Google Play</div>
          <small class="font-weight-thin">Hemen İndir</small>
        </div>
      </v-btn>

      <v-btn
        class="white--text ma-1"
        :href="isVatan ? 'https://apps.apple.com/us/app/vatansms-ba%C5%9Fl%C4%B1kl%C4%B1-toplu-sms/id6448785525' : ''"
        target="blank"
        large
        color="black"
      >
        <v-icon class="mr-4" left large>mdi-apple</v-icon>
        <div class="text-left">
          <div class="text-capitalize">App Store</div>
          <small class="font-weight-thin">Hemen İndir</small>
        </div>
      </v-btn>

      <v-btn
        class="white--text ma-1 pl-3"
        :href="isVatan ? 'https://appgallery.huawei.com/app/C108212643' : ''"
        target="blank"
        large
        color="black"
      >
        <v-img
          class="mr-3"
          max-height="36"
          max-width="36"
          src="@/assets/huawei-icon.png"
        ></v-img>
        <div class="text-left">
          <div class="text-capitalize">AppGallery</div>
          <small class="font-weight-thin">Hemen İndir</small>
        </div>
      </v-btn>

    </div>
  </section>
</template>

<script>
export default {
  props: {
    isVatan: {
      required: true,
      typeof: Boolean
    }
  }
};
</script>

<style lang="scss" scoped>
  .download-app {
    display: flex;
    flex-direction: column;
    position: relative;
    background: orange;
    overflow: hidden;
    height: 100%;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;

      width: 1rem;
      height: 100%; 
      background: orangered;
    }

    &__img {
      position: relative;
      z-index: 1;
    }
  }


  .pill {
    position: absolute;
    border-radius: 20rem;
    background-color: orangered;
    transform: translate(40rem, -40rem) rotate(-45deg);
    animation: rain 1s ease-in forwards;

    &--sm {
      width: 10rem;
      height: 5rem;
    }
    &--md {
      width: 20rem;
      height: 10rem;
    }
    &--lg {
      width: 30rem;
      height: 15rem;
    }
  }

  @keyframes rain {
    0% {
      transform: translate(40rem, -40rem) rotate(-45deg);
    }
    100% {
      transform: translate(0, 0) rotate(-45deg);
    }
  }
</style>